import { mutatorAction } from "satcheljs";
import getScenarioStore from "../selectors/getScenarioStore";
import SearchScenarioId from "../store/schema/SearchScenarioId";
import type { SearchScenarioStore } from "../store/schema/SearchStore";

export const setCalendarQueryInstrumentationMutator: (context: SearchScenarioStore["calendarQueryInstrumentation"]) => void = mutatorAction("setCalendarQueryInstrumentation", (context: SearchScenarioStore["calendarQueryInstrumentation"]): void => {
    getScenarioStore(SearchScenarioId.Calendar).calendarQueryInstrumentation = context;
});
